import { Box, useStyleConfig } from "@chakra-ui/react";
function Card(props) {
  const { onPress, variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });

  return (
    <Box onClick={() => onPress && onPress()} __css={styles} {...rest}>
      {children}
    </Box>
  );
}

export default Card;
